<h2>Example Form</h2>

<form-factory
  class="update-input"
  [formGroup]="updateForm"
  [model]="updateInputs[0]"
  (onChange)="toggleDisableOnTestInputs($event)"></form-factory>
<form-factory
  class="update-input"
  [formGroup]="updateForm"
  [model]="updateInputs[1]"
  (onChange)="toggleAdminOnTestInputs($event)"></form-factory>
<form-factory
  class="update-input"
  [formGroup]="updateForm"
  [model]="updateInputs[2]"
  (onChange)="toggleChangeOnTestInputs($event)"></form-factory>
<div class="clearfix"></div>

<hr>

<form class="form" [formGroup]="testForm">
  <form-factory
    *ngFor="let testInput of testInputs; trackBy: trackByIndex"
    [formGroup]="testForm"
    [model]="testInput"
    (onChange)="onChange($event, model)"
    (onInput)="onInput($event, model)"></form-factory>
</form>
<app-button (onClick)="submit()" text="Submit"></app-button>

<h2>Abstraction Specific Example Form</h2>
<form class="form" [formGroup]="abstractionTestForm">
  <form-factory
    *ngFor="let abstractionTestInput of abstractionTestInputs; trackBy: trackByIndex"
    [formGroup]="abstractionTestForm"
    [model]="abstractionTestInput"
    (onChange)="onChange($event, model)"
    (onInput)="onInput($event, model)"></form-factory>
</form>
<app-button (onClick)="submit()" text="Submit"></app-button>

<h2>Groups Example Form</h2>
<form class="form" [formGroup]="groupsTestForm">
  <form-factory
    *ngFor="let groupsTestInput of groupsTestInputs; trackBy: trackByIndex"
    [formGroup]="groupsTestForm"
    [model]="groupsTestInput"
    (onChange)="onChange($event, model)"
    (onInput)="onInput($event, model)"></form-factory>
</form>
<app-button (onClick)="submit()" text="Submit"></app-button>